import React from 'react';
import {Helmet} from "react-helmet";
import { Link } from "react-router-dom";

function About() {
  return (
    <> 
    <Helmet>
    <meta charset="utf-8" />
    <title>About | Eagle Eye Enterprises</title>
    <link
          rel="canonical"
          href="https://eagleeyeenterprises.co.in/"
        /> 
    <meta name="description" content="Eagle Eye Enterprises CCTV security services CCTV cameras are one of the important elements in securing our businesses and daily lives. We provide design and installation of end-to-end CCTV security systems right from cameras (both analog & IP) to network to NVR's to server/storage to power backup solution to monitoring solution etc. We also provide wireless camera solutions; we have everything you need to customize your business security. We provide Best Performance Surveillance Security Systems at competitive price"/>
    <meta name="keywords" content="eagle eye enterprises EEE, Kankarbhagh, Patna"/>
    </Helmet>
    {/* <!-- Page Header Start --> */}
  <div className="container-fluid page-about py-3 mb-5">
  <div className="container py-5">
    <h1 className="display-3 text-white mb-3 animated slideInDown">About Us</h1>
    <nav aria-label="breadcrumb animated slideInDown">
      <ol className="breadcrumb">
        <li className="breadcrumb-item"><Link className="text-white" to="/">Home</Link></li> 
        <li className="breadcrumb-item text-white active" aria-current="page">About</li>
      </ol>
    </nav>
  </div>
</div>
    {/* <!-- Page Header End --> */}


  <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0">
  <div className="container about px-lg-0">
    <div className="row g-0 mx-lg-0">
      <div className="col-lg-6 ps-lg-0" style={{minHeight: 400}}>
        <div className="position-relative h-100">
          <img className="position-absolute img-fluid w-100 h-100" src="assets/img/about.jpg" style={{objectFit: 'cover'}} alt="pic1" />
        </div>
      </div>
      <div className="col-lg-6 about-text py-5 wow fadeIn" data-wow-delay="0.5s">
        <div className="p-lg-5 pe-lg-0">
          <div className="bg-primary mb-3" style={{width: 60, height: 2}} />
          <h1 className="display-5 mb-4">About Us</h1>
          <p className="mb-2" style={{color:'#000000',textAlign:'justify',fontWeight:'500'}}> 
          Eagle Eye Enterprises is based in Patna, Kankarbagh.
          We take care of everything from the initial site survey, system design, install by NSI-qualified engineers, and finally maintenance and monitoring of your commercial CCTV system to give you the peace of mind that your property and premises are protected when you’re not on-site.
         </p>
         <p className="mb-4 pb-2" style={{color:'#000000',textAlign:'justify',fontWeight:'500'}}> We provide Sale of CCTV camera, GPS, Intercom, Software Networking and Computer maintenance for Home/Companies. We conduct installation services for all types of CCTV.</p>
              </div>
      </div>
    </div>
  </div>
</div>  






    </>
  )
}

export default About